import { useState, useEffect, useCallback } from 'react';
import { readingPracticeRequestsService } from '../../../services/request-service';

export const useReadingPracticeStatus = (id = null, autoFetch = true) => {
  const [requestId, setRequestId] = useState(id);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const fetchStatus = useCallback(async (statusId = requestId) => {
    if (!statusId) return;
    
    setIsLoading(true);
    setError(null);
    try {
      const result = await readingPracticeRequestsService.getRequestById(statusId);
      setData(result);
      return result;
    } catch (err) {
      setError(err.message || 'Failed to fetch status');
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, [requestId]);

  // Set a new request ID
  const setId = useCallback((newId) => {
    setRequestId(newId);
  }, []);

  // Sync prop id to state requestId
  useEffect(() => {
    if (id) {
      setRequestId(id);
    }
  }, [id]);

  // Auto-fetch when ID is available or changes
  useEffect(() => {
    if (requestId && autoFetch) {
      fetchStatus(requestId);
    }
  }, [requestId, autoFetch, fetchStatus]);

  // Polling logic for pending/generating/drafting states
  useEffect(() => {
    if (!requestId || !autoFetch || !data) return;

    const activeStatus = data.status;
    const needsPolling = ['PENDING', 'GENERATING_CONTENT', 'DRAFTING'].includes(activeStatus);

    if (!needsPolling) return;

    const interval = setInterval(() => {
      fetchStatus(requestId).catch((err) => console.error('Polling fetch failed:', err));
    }, 5000);

    return () => clearInterval(interval);
  }, [requestId, autoFetch, data, fetchStatus]);

  return { 
    fetchStatus, 
    setId, 
    isLoading, 
    error, 
    data,
    requestId
  };
};
